"use strict";exports.__esModule=true;exports.default=void 0;var enUS={decimal:".",thousands:",",grouping:[3],prefix:"$",suffix:""};var _default=enUS;exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/utils/src/number-converter/locales/en-US.js
// module id = /j5I
// module chunks = 5